import React, { useEffect, useRef, useState, memo } from 'react';
import { useTranslation } from 'react-i18next';

interface LazyMediaProps {
  src: string;
  type?: 'img' | 'video';
  alt?: string;
  poster?: string;
  style?: React.CSSProperties;
  onClick?: () => void;
  className?: string;
}

const LazyMediaMobile: React.FC<LazyMediaProps> = ({
  src,
  type = 'img',
  alt = '',
  poster,
  style = {},
  onClick,
  className,
}) => {
  const { t } = useTranslation();
  const ref = useRef<HTMLDivElement>(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const node = ref.current;
    if (!node) return;

   const observer = new IntersectionObserver(
  ([entry]) => {
    if (entry.isIntersecting) {
      setIsVisible(true);
      observer.disconnect();
    }
  },
  {
    rootMargin: '600px',
    threshold: 0.1,
  }
);


    observer.observe(node);
    return () => {
      if (node) observer.unobserve(node);
    };
  }, []);

  return (
    <div ref={ref} style={{ minHeight: '20px' }}>
      {isVisible && type === 'img' && (
        <img
          src={src}
          alt={alt}
          loading="lazy"
          decoding="async"
          style={{ display: 'block', ...style }}
          onClick={onClick}
          className={className}
        />
      )}
      {isVisible && type === 'video' && (
        <video
          src={src}
          poster={poster}
          controls
          preload="metadata" 
          style={{ display: 'block', ...style }}
          onClick={onClick}
          className={className}
        >
          {t('lazymedia.videoNotSupported')}
        </video>
      )}
    </div>
  );
};

export default memo(LazyMediaMobile);
